import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {IoniconsFilled} from '@pt/pt-models';
import {WidgetCheckboxV0NodeDto} from './models/widget-checkbox-v0-node.dto';
import {WidgetCheckboxV0ChildrenDto} from "./models/widget-checkbox-v0-children.dto";
import {WidgetCheckboxV0Mode} from "./models/widget-checkbox-v0-mode";
import { Observable } from 'rxjs';

@Component({
  selector: 'pt-widget-checkbox-v0-preview',
  template: `
    <ng-container *ngIf='loading; then LOADING; else PREVIEW'></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf='noData; then NODATA; else DATA'></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel"></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>

        <pt-widget-checkbox-v0-edit-children
          *ngIf="mode === WidgetCheckboxV0Mode.CHILDREN"
          [checkbox]="previewData"
          [editMode]="false"
          [childrenData]="childrenData">
        </pt-widget-checkbox-v0-edit-children>

        <div [ngClass]='[items.length > 5 ? "wcv0" : ""]' *ngIf="mode !== WidgetCheckboxV0Mode.CHILDREN">
          <div class='wcv0-item' *ngFor='let item of items'
               [ngClass]='[items.length <= 5 ? "w-100" : ""]'>
            <div class="d-flex align-items-center">
              <pt-icon class="widget-icon-preview-color me-1 d-flex" [key]='IconCheckFilled'></pt-icon>
              <div class="d-inline">
                <div class="custom-item" style='margin-top: 2px'>{{ item.label }}</div>
                <pt-w-help class="custom-item" [help]='item?.help'></pt-w-help>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>
  `,
  styles: [`
    .custom-item {
      display: inline;
      /*min-height: 25px;*/
    }

    .wcv0 {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 5px;
      row-gap: 10px;
    }

    .wcv0-item {

      width: 100%;
      display: block;
      padding: 0 2px;
      min-height: 24px;
      margin-bottom: 1px;
      line-height: 24px;
    }

    .widget-checkbox-v0-preview {
      margin: 0;
      padding-left: 5px;
    }

    .widget-checkbox-v0-preview li {
      display: flex;
    }

    .widget-checkbox-v0-preview span {
      margin-top: 2px;
    }
  `]
})
export class WidgetCheckboxV0PreviewComponent implements OnChanges {
  @Input() noDataLabel?: string;
  @Input() hasChildren: boolean
  @Input() childrenData: WidgetCheckboxV0ChildrenDto[];
  @Input() mode: WidgetCheckboxV0Mode;

  @Input() previewData: WidgetCheckboxV0NodeDto[];
  @Input() loading: boolean;

  WidgetCheckboxV0Mode = WidgetCheckboxV0Mode;
  items: WidgetCheckboxV0NodeDto[] = [];
  noData = true;

  IconCheckFilled = IoniconsFilled.checkbox;


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.previewData) {

      this.items = [];
      if (this.previewData) {
        this.previewData.forEach((categoryNode: WidgetCheckboxV0NodeDto) => {
          if (categoryNode.checked) {
            this.items.push(categoryNode);
          }
          categoryNode?.children?.forEach((childrenNode: WidgetCheckboxV0NodeDto) => {
            if (childrenNode.checked) {
              this.items.push(childrenNode);
            }
          });
        });
      }
      this.noData = this.items?.length === 0;
    }
  }


}
